import React from 'react';
import { InterPoint } from '@saviynt/common';
import { Box, Typography } from '@saviynt/design-system';

import { SodUserCard } from '../../../../shared/components';
import { CF_NEU_BLD, CF_NEU_STL } from '../../../../shared/constants';
import { useInvertedLocalize } from '../../../../shared/hooks/use-invertedlocalize';

interface UserChipProps {
  firstName: string | null;
  lastName: string | null;
  userName: string | null;
  isPrefixInterpoint?: boolean;
}

/**
 * For actual vs potential chip
 */
function UserChip({
  firstName,
  lastName,
  userName,
  isPrefixInterpoint,
}: UserChipProps) {
  if (!firstName && !lastName && !userName) {
    return null;
  }

  if (
    firstName?.trim().length === 0 &&
    lastName?.trim().length === 0 &&
    userName?.trim().length === 0
  ) {
    return null;
  }

  return (
    <>
      <SodUserCard
        firstName={firstName ?? undefined}
        lastName={lastName ?? undefined}
        userName={userName ?? undefined}
        link=''
      />
      {isPrefixInterpoint && <InterPoint color='neutralBold' font='body2' />}
    </>
  );
}

UserChip.defaultProps = {
  isPrefixInterpoint: true,
};

interface AccountChipProps {
  visibleAccountName: string;
  accountCount: number;
  isPrefixInterpoint?: boolean;
}

/**
 * For account chip
 */
function AccountChip({
  visibleAccountName,
  accountCount,
  isPrefixInterpoint,
}: AccountChipProps) {
  const l = useInvertedLocalize();

  return (
    <Box className='Sod-ViolationsTabList-listRowAccountStat'>
      <Typography kind='body2' color={CF_NEU_STL} lineLimit={1}>
        {l('Account')}:
      </Typography>
      <Typography
        kind='body2'
        desktop='body2-d'
        mobile='body2-d'
        className={CF_NEU_BLD}>
        {visibleAccountName}
        {accountCount > 1 && (
          <span className='Sod-ViolationsTabList-listRowAccountStat--isCount'>
            &nbsp;+{accountCount - 1}
          </span>
        )}
      </Typography>
      {isPrefixInterpoint && <InterPoint color='neutralBold' font='body2' />}
    </Box>
  );
}

AccountChip.defaultProps = {
  isPrefixInterpoint: false,
};

interface ColumnChipProps {
  name: string;
  value: string;
  isPrefixInterpoint: boolean;
}

/**
 * For column chip - extended columns to show
 */
function ColumnChip({
  name,
  value,
  isPrefixInterpoint = true,
}: ColumnChipProps) {
  return (
    <Box className='Sod-ViolationsTabList-listRowAccountStat'>
      <Typography kind='body2' color={CF_NEU_STL} lineLimit={1}>
        {name}:
      </Typography>
      <Typography
        kind='body2'
        desktop='body2-d'
        mobile='body2-d'
        className={CF_NEU_BLD}>
        {value}
      </Typography>
      {isPrefixInterpoint && <InterPoint color='neutralBold' font='body2' />}
    </Box>
  );
}

export { AccountChip, ColumnChip, UserChip };
